package system.network

import assets.*
import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.inject
import com.soywiz.korge.box2d.*
import com.soywiz.korge.view.*
import com.soywiz.korge.view.Camera
import com.soywiz.korge.view.camera.*
import component.*
import input.*
import models.*
import system.single.*
import utils.PlayerBuilder.buildPlayerContainer

class NetworkPlayerSpawnSystem(
    private val physicWorld: org.jbox2d.dynamics.World = inject(),
    private val cameraContainer: CameraContainer = inject(),
    private val camera: Camera = inject(),
    private val inputControllerData: InputControllerData = inject()
) : IteratingSystem(World.family { all(PlayerComponent) }) {

    var respawnPlayer = false
    private var sessionInfo: SessionInfo? = null

    fun firstConnect(sessionInfo: SessionInfo) {
        this.sessionInfo = sessionInfo
        respawnPlayer = true
    }

    override fun onTick() {
        super.onTick()

        if (respawnPlayer) {
            respawnPlayer = false
            val info = sessionInfo ?: return

            val posX = info.player.x
            val posY = info.player.y

            val sprite = Sprite().apply {
                scale = 2.0
                position(-5, -5)
            }

            val view = camera.buildPlayerContainer(
                posX * physicWorld.customScale,
                posY * physicWorld.customScale,
                sprite,
                physicWorld
            )

//            cameraContainer.follow(view)

            world.entity {
                it += SpriteAnimationComponent(animationPrefix = "ninja-frog").apply {
                    nextAnimation = PlayerAnimationTypes.IDLE_RIGHT.name
                    this.sprite = sprite
                }
                it += PhysicComponent(
                    body = view.body!!,
                    vXmax = 10f
                )
//                it += PlayerComponent(
//                    AbilitySelector(
//                        inputControllerData.firstAbilityButton,
//                        inputControllerData.secondAbilityButton
//                    )
//                ).apply {
//                    direction = BodyDirection.RIGHT
//                }

                it += StateComponent().apply {
                    state = StateComponent.STATE_FALLING
                }

                it += NetworkInputDataComponent(info.player.id)

                it += PhysicSnapshotStateComponent()

            }
        }
    }

    override fun onTickEntity(entity: Entity) {
        if (respawnPlayer) {
            entity.remove()
            cameraContainer.unfollow()
        }
    }
}
